<template>
    <div>
        <div class="wrapper">
            <div class="col12 pt-0">
                <h1 class="page_title">まもりこサービス対応機器「人感センサー」購入のお申し込み</h1>
                <div class="signup_flow">
                    <ol>
                        <li><span>1</span>ログ <br class="on-sp" />イン</li>
                        <li><span>2</span>申込 <br class="on-sp" />内容</li>
                        <li><span>3</span>情報 <br class="on-sp" />入力</li>
                        <li class="current"><span>4</span>支払</li>
                        <li><span>5</span>完了</li>
                    </ol>
                </div>
                <!-- signup_flow -->
            </div>
        </div>
        <!-- wrapper -->
        <section class="container">
            <div class="wrapper">
                <h2 class="col5 section_title">
                    <strong>支払い方法の入力</strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <Cards ref="cards" :currentCards="cards" :invoiceClientSecret="invoiceClientSecret" @infoClick="$emit('openAlertModal', $event)"></Cards>
                    <p class="submit_btn">
                        <input type="submit" value="この方法で支払う" onsubmit="return false;" @click="confirm" />
                    </p>
                    <p class="submit_btn no-check no-arrow mt-3em">
                        <a href="javascript:void(0)" @click="cancel">キャンセル</a>
                    </p>
                </div>

                <!-- wrap_pr_2col input_area -->
            </div>
            <!-- wrapper -->
        </section>
        <!-- container -->
    </div>
</template>

<script>
import Cards from "../../../../../../../WebApp/Commons/components/Cards.vue";
import SiteConstants from "../../../../../../../Commons/SiteConstants";

export default {
    components: {
        Cards
    },
    beforeRouteEnter(to, from, next) {
        // 特定の画面以外からの遷移は禁止
        if (from.name !== "ContractConfirm") {
            next("/login");
            return;
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        // 「入力内容を修正」ボタンや、ブラウザで戻られた場合に、入力項目を復元する
        // アカウントなし用に上書き（ログインユーザはnextのAPIで返却されるEmailが入っており画面上変更不可になっているので同じ内容で上書きされるだけ）
        to.params.customerEmail = this.customerEmail;
        to.params.customerName = this.customerName;
        to.params.customerKana = this.customerKana;
        to.params.customerPostalCode = this.customerPostalCode;
        to.params.customerPrefecture = this.customerPrefecture;
        to.params.customerCity = this.customerCity;
        to.params.customerAddress = this.customerAddress;
        to.params.customerTel = this.customerTel;
        to.params.copyAddress = this.copyAddress;
        to.params.destinationName = this.destinationName;
        to.params.destinationKana = this.destinationKana;
        to.params.destinationPostalCode = this.destinationPostalCode;
        to.params.destinationPrefecture = this.destinationPrefecture;
        to.params.destinationCity = this.destinationCity;
        to.params.destinationAddress = this.destinationAddress;
        to.params.destinationTel = this.destinationTel;
        to.params.searchedCustomerPostalCode = this.searchedCustomerPostalCode;
        to.params.searchedDestinationPostalCode = this.searchedDestinationPostalCode;
        to.params.searchedCustomerAddressInfoEmpty = this.searchedCustomerAddressInfoEmpty;
        to.params.searchedDestinationAddressInfoEmpty = this.searchedDestinationAddressInfoEmpty;

        to.params.cards = this.cards;
        to.params.card = this.card;
        to.params.setDefault = this.setDefault;
        to.params.isRequiredCredit = this.isRequiredCredit;
        to.params.planId = this.planId;
        to.params.product = this.product;
        to.params.code = this.code;
        to.params.promotionCode = this.promotionCode;

        to.params.invoiceNo = this.invoiceNo;

        next();
    },
    methods: {
        cancel: function () {
            this.$emit("openConfirmModal", "申込みをキャンセルしますか？", () => {
                // TOP画面へ遷移
                this.$router.push({
                    name: "Top",
                    params: {}
                });
            });
        },
        confirm: function () {
            if (!this.$refs.cards.isCardSelect()) {
                this.$emit("openAlertModal", "支払い方法を入力してください", null);
                return;
            }
            this.$emit(
                "openConfirmYesModal",
                "この内容で支払いをしてもよろしいですか？ボタン押下後はブラウザの「戻る」ボタンや「更新」ボタンを押さないでください。",
                async () => {
                    this.$emit("showSpinner", "処理中です。処理中はブラウザの「戻る」ボタンや「更新」ボタンを押さないでください。");
                    this.$axios(
                        "POST",
                        "/payment/init",
                        {
                            customer: {
                                name: this.customerName,
                                kana: this.customerKana,
                                ageGroup: this.ownerAgeGroup,
                                gender: this.ownerGender,
                                postalCode: this.customerPostalCode,
                                prefecture: this.customerPrefecture,
                                city: this.customerCity,
                                address: this.customerAddress,
                                tel: this.customerTel,
                                email: this.customerEmail
                            },
                            destination: {
                                name: this.copyAddress ? this.customerName : this.destinationName,
                                kana: this.copyAddress ? this.customerKana : this.destinationKana,
                                postalCode: this.copyAddress ? this.customerPostalCode : this.destinationPostalCode,
                                prefecture: this.copyAddress ? this.customerPrefecture : this.destinationPrefecture,
                                city: this.copyAddress ? this.customerCity : this.destinationCity,
                                address: this.copyAddress ? this.customerAddress : this.destinationAddress,
                                tel: this.copyAddress ? this.customerTel : this.destinationTel
                            },
                            product: this.product,
                            productId: document.productId,
                            code: this.code,
                            promotionCode: this.promotionCode,

                            np: document.np,

                            deliveryDate: this.deliveryDate,
                            deliveryTime: this.deliveryTime
                        },
                        // eslint-disable-next-line no-unused-vars
                        async (res) => {
                            // 取得したインボイス情報を支払い用に保持
                            this.invoiceId = res.data.invoiceId;
                            this.invoiceClientSecret = res.data.invoiceClientSecret;

                            if (!this.payButtonEnabled) {
                                return;
                            }
                            this.payButtonEnabled = false;
                            await this.payInvoice(this.invoiceClientSecret);
                        }
                    );
                },
                () => {
                    // いいえの場合は処理しない
                    return;
                }
            );
        },
        payInvoice: async function (clientSecret) {
            try {
                await this.$refs.cards.payInvoice(clientSecret);

                await this.complete();
            } catch (err) {
                if(this.promotionCode && this.promotionCode.init && this.promotionCode.init.code){
                    this.$axios(
                        "POST",
                        "/payment/deletePromotionCodeFromCustomer",
                        {},
                        // eslint-disable-next-line no-unused-vars
                        (res) => {
                            this.$emit("hideSpinner");
                            this.$emit("openAlertModal", err.message, null);
                            this.payButtonEnabled = true;
                        }
                    );
                } else {
                    this.$emit("hideSpinner");
                    this.$emit("openAlertModal", err.message, null);
                    this.payButtonEnabled = true;
                }
            }
        },
        complete: async function () {
            this.$axios(
                "POST",
                "/payment/order",
                {
                    invoiceId: this.invoiceId,
                    productId: document.productId
                },
                // eslint-disable-next-line no-unused-vars
                (res) => {
                    this.$emit("hideSpinner");
                    // 申し込み完了画面へ遷移
                    this.invoiceNo = res.data.invoiceNo;
                    this.$router.push({
                        name: "ContractComplete"
                    });
                }
            );
        },
        init: function () {
            this.$emit("showSpinner", "処理中です。処理中はブラウザの「戻る」ボタンや「更新」ボタンを押さないでください。");
            this.$axios(
                "POST",
                "/payment/init",
                {
                    customer: {
                        name: this.customerName,
                        kana: this.customerKana,
                        ageGroup: this.ownerAgeGroup,
                        gender: this.ownerGender,
                        postalCode: this.customerPostalCode,
                        prefecture: this.customerPrefecture,
                        city: this.customerCity,
                        address: this.customerAddress,
                        tel: this.customerTel,
                        email: this.customerEmail
                    },
                    destination: {
                        name: this.copyAddress ? this.customerName : this.destinationName,
                        kana: this.copyAddress ? this.customerKana : this.destinationKana,
                        postalCode: this.copyAddress ? this.customerPostalCode : this.destinationPostalCode,
                        prefecture: this.copyAddress ? this.customerPrefecture : this.destinationPrefecture,
                        city: this.copyAddress ? this.customerCity : this.destinationCity,
                        address: this.copyAddress ? this.customerAddress : this.destinationAddress,
                        tel: this.copyAddress ? this.customerTel : this.destinationTel
                    },
                    product: this.product,
                    productId: document.productId,
                    code: this.code,
                    promotionCode: this.promotionCode,

                    np: document.np,

                    deliveryDate: this.deliveryDate,
                    deliveryTime: this.deliveryTime
                },
                // eslint-disable-next-line no-unused-vars
                (res) => {
                    // 取得したインボイス情報を支払い用に保持
                    this.invoiceId = res.data.invoiceId;
                    this.invoiceClientSecret = res.data.invoiceClientSecret;
                }
            );
        }
    },
    data: function () {
        return {
            prefectureNames: [],
            customerName: "",
            customerNameInvalid: false,
            customerKana: "",
            customerKanaInvalid: false,
            customerPostalCode: "",
            customerPostalCodeInvalid: false,
            customerPrefecture: "",
            customerPrefectureInvalid: false,
            customerCity: "",
            customerCityInvalid: false,
            customerAddress: "",
            customerAddressInvalid: false,
            customerTel: "",
            customerTelInvalid: false,
            copyAddress: true,
            destinationName: "",
            destinationNameInvalid: false,
            destinationKana: "",
            destinationKanaInvalid: false,
            destinationPostalCode: "",
            destinationPostalCodeInvalid: false,
            destinationPrefecture: "",
            destinationPrefectureInvalid: false,
            destinationCity: "",
            destinationCityInvalid: false,
            destinationAddress: "",
            destinationAddressInvalid: false,
            destinationTel: "",
            destinationTelInvalid: false,
            searchedCustomerPostalCode: false,
            searchedDestinationPostalCode: false,
            searchedCustomerAddressInfoEmpty: false,
            searchedDestinationAddressInfoEmpty: false,
            cards: [],
            card: null,
            setDefault: true,
            isRequiredCredit: true,
            product: {},
            customerEmail: "",
            customerEmailInvalid: false,
            isLogin: !document.isWithoutLogin,
            invoiceId: "",
            invoiceClientSecret: "",
            payButtonEnabled: true
        };
    },
    created() {
        this.prefectureNames = SiteConstants.PrefectureNames;
        this.customerEmail = this.$route.params.customerEmail;

        // サービス料金
        this.product = this.$route.params.product;
        this.code = this.$route.params.code;
        this.promotionCode = this.$route.params.promotionCode;
        //  会員情報
        this.customerName = this.$route.params.customerName;
        this.customerKana = this.$route.params.customerKana;
        this.customerPostalCode = this.$route.params.customerPostalCode;
        this.customerPrefecture = this.$route.params.customerPrefecture ? this.$route.params.customerPrefecture : "";
        this.customerCity = this.$route.params.customerCity;
        this.customerAddress = this.$route.params.customerAddress;
        this.customerTel = this.$route.params.customerTel;
        // 配送先
        this.copyAddress = this.$route.params.copyAddress === undefined ? true : this.$route.params.copyAddress;
        this.destinationName = this.$route.params.destinationName;
        this.destinationKana = this.$route.params.destinationKana;
        this.destinationPostalCode = this.$route.params.destinationPostalCode;
        this.destinationPrefecture = this.$route.params.destinationPrefecture ? this.$route.params.destinationPrefecture : "";
        this.destinationCity = this.$route.params.destinationCity;
        this.destinationAddress = this.$route.params.destinationAddress;
        this.destinationTel = this.$route.params.destinationTel;
        // 既に郵便番号が設定されている場合は郵便番号検索は不要とする
        if (this.$route.params.copiedStripePostalCode && this.$route.params.customerPostalCode) {
            this.searchedCustomerPostalCode = true;
        } else {
            this.searchedCustomerPostalCode = this.$route.params.searchedCustomerPostalCode;
        }
        this.searchedDestinationPostalCode = this.$route.params.searchedDestinationPostalCode;
        this.searchedCustomerAddressInfoEmpty = this.$route.params.searchedCustomerAddressInfoEmpty;
        this.searchedDestinationAddressInfoEmpty = this.$route.params.searchedDestinationAddressInfoEmpty;

        this.cards = this.$route.params.cards;
        this.card = this.$route.params.card;
        this.setDefault = this.$route.params.setDefault;

        // クレジットカード入力要否
        this.isRequiredCredit = this.$route.params.isRequiredCredit;
    }
};
</script>

<style scoped>
/* iosで青字になる  */
select {
    color: #000000;
}
</style>
